import PersonImg from '../assets/images/team1.jpg'
export const Companydata=[
    {
        id:"Denial Enterprise",
        company_name:"Denial Enterprise",
        tagline:"INSIGHT, STRATEGY, RESULT",
        address:"Q-210, 2nd Fl., Radhika Point, Opp. PMB Centre, Chhaprabhatha Rd., New-Katargam, Surat - 394107",
        phoneno:"+91 9558970900",
        emailid:"deven.v@denialenterprise.com"
    }
];

export const teamMembers = [
    {
        id: 1,
        name: "Deven.V",
        role: "Co-founder, CEO",
        desc: "bridge the gap between technical complexity and MNC business goals. I specialize in cracking high-value deals and managing the full lifecycle of energy assets—from 4.5 MW connections to turnkey EVCS networks—ensuring every project exceeds the rigorous standards of partners like Reliance BP Mobility Ltd.",
        
    },
    {
        id: 2,
        name: "Dhirajlal.P",
        role: "Field Operations Manager",
      
        desc: "As our Field Operations Manager, Dhirajlal leads from the ground, overseeing every technical process and equipment deployment with precision. He is the backbone of our site execution, ensuring that all field works are managed seamlessly and move from plan to reality."
    },
    {
        id: 3,
        name: "Vishva Vekariya",
        role: "Assistent",
        
        desc: "As Operations Assistant, Vishva manages the firm's administrative engine, overseeing technical documentation and digital correspondence. Her precision ensures our office management meets the rigorous standards required for high-stakes MNC projects."
    },
    {
        id: 4,
        name: "Sumit",
        role: "Field Enginerr",
        desc: "As Field Engineer, Sumit oversees all on-site engineering works, ensuring technical designs are executed with absolute precision. He bridges the gap between complex blueprints and ground-level implementation to maintain our high infrastructure standards."
    },
    {
        id: 5,
        name: "Pooja Mishra",
        role: "Finance Manager",
        desc: "As Finance Manager, Pooja Mishra oversees the firm's fiscal strategy, managing project budgets and ensuring transparent financial reporting. Her expertise in high-stakes auditing and MNC-standard billing keeps our large-scale deployments financially sound and compliant."
    },
    {
        id: 6,
        name: "Nikunj Mangroliya",
        role: "Finance Advisor",
        desc: "As Finance Advisor, Nikunj Mangroliya provides the strategic fiscal guidance necessary for large-scale infrastructure investments and MNC contracts. He specializes in risk assessment and long-term financial planning to ensure the sustainable growth of our project portfolio."
    }
];